<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1>{{'予約状況：編集' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addReservation()" [disabled]="!reservationFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

      <div class="dialog-left" fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
        <form class="form" [formGroup]="reservationFormGroup">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'予約番号' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_no">
                {{ reservation.reservation_no }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'展示ID' | translate}}</label>
              <div *ngIf="!!reservation && reservation.exhibit_id">
                {{ reservation.exhibit_id }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'予約施設' | translate}}</label>
              <div *ngIf="!!reservationFacilities">
                <div *ngFor="let reservationFacility of reservationFacilities">
                  <div
                    *ngIf="!!reservation && reservation.reservation_facility_id === reservationFacility.reservation_facility_id">
                    {{ reservationFacility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}
                  </div>
                </div>
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'属性' | translate}}</label>
              <div *ngFor="let reservationFacilityAttribute of (reservationFacilityAttributes | async)">
                <div
                  *ngIf="!!reservation && reservation.reservation_facility_attribute_id === reservationFacilityAttribute.attribute_id">
                  {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'利用日' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_start_date">
                {{ reservation.reservation_start_date | date: 'yyyy/MM/dd' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'利用日(延泊)' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_end_date">
                {{ reservation.reservation_end_date | date: 'yyyy/MM/dd' }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'利用時間' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_times">
                <div *ngFor="let reservation_time of reservation.reservation_times">
                  {{ reservation_time.item }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'SPLATS QRコード' | translate}}</label>
              <div *ngIf="!!reservation && reservation.splats_qr_code">
                {{ reservation.splats_qr_code }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'SPLATS ゲストID' | translate}}</label>
              <div *ngIf="!!reservation && reservation.splats_guest_id">
                {{ reservation.splats_guest_id }}
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'登録日時' | translate}}</label>
              <div *ngIf="!!reservation && reservation.created">
                {{ reservation.created | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'更新日時' | translate}}</label>
              <div *ngIf="!!reservation && reservation.updated">
                {{ reservation.updated | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
          </div>
          <br>
          <div *ngIf="!!reservation && reservation.reservation_cancel_date" fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'キャンセル日時' | translate}}</label>
              <div>
                {{ reservation.reservation_cancel_date | date: 'yyyy/MM/dd HH:mm:ss' }}
              </div>
            </div>
            <div fxFlex="50%">
              <label>{{'キャンセル実行者' | translate}}</label>
              <div *ngIf="!!reservation && reservation.reservation_cancel_user">
                {{ reservation.reservation_cancel_user }}
              </div>
            </div>
          </div>
          <br *ngIf="!!reservation && reservation.reservation_cancel_date">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxFlex="50%">
              <label>{{'メール送信状況' | translate}}</label>
              <div *ngFor="let mailSendStatus of mailSendStatuses">
                <div *ngIf="!!reservation && reservation.mail_send_status === mailSendStatus">
                  {{ mailSendStatus | mailSendStatus }}
                </div>
              </div>
            </div>
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%"
              *ngIf="[RESERVATION_STATUS_RECEPTION, RESERVATION_STATUS_COMPLETE].includes(reservation?.reservation_status!)">
              <mat-label>{{'予約状況' | translate}}</mat-label>
              <mat-select placeholder="{{'予約状況' | translate}}" id="reservationStatus"
                formControlName="reservationStatus">
                <mat-option *ngIf="reservationStatusControl.value === RESERVATION_STATUS_RECEPTION"
                  [value]="RESERVATION_STATUS_RECEPTION">{{ RESERVATION_STATUS_RECEPTION | reservationStatus
                  }}</mat-option>
                <mat-option *ngIf="reservationStatusControl.value === RESERVATION_STATUS_COMPLETE"
                  [value]="RESERVATION_STATUS_COMPLETE">{{ RESERVATION_STATUS_COMPLETE | reservationStatus
                  }}</mat-option>
                <mat-option [value]="RESERVATION_STATUS_CANCEL">{{ RESERVATION_STATUS_CANCEL | reservationStatus
                  }}</mat-option>
              </mat-select>
              <mat-error *ngIf="reservationStatusControl.invalid">{{ getErrorMessageToReservationStatus() }}</mat-error>
            </mat-form-field>
            <div fxFlex="50%"
              *ngIf="![RESERVATION_STATUS_RECEPTION, RESERVATION_STATUS_COMPLETE].includes(reservation?.reservation_status!)">
              <label>{{'予約状況' | translate}}</label>
              <div *ngFor="let reservationStatus of reservationStatuses">
                <div *ngIf="!!reservation && reservation.reservation_status === reservationStatus">
                  {{ reservationStatus | reservationStatus }}
                </div>
              </div>
            </div>
          </div>
          {{'▼メモ' | translate}}
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="100%">
              <textarea matInput type="text" placeholder="" rows="5" formControlName="memo"></textarea>
            </mat-form-field>
          </div>
          <br>
        </form>
      </div>

      <div class="dialog-right" fxLayout="column" fxLayoutGap="10px" fxFlex="100%">
        <form class="form" [formGroup]="reservationFormGroup">
          <div fxLayout="row" fxLayoutGap="20px">
            {{'▼基本項目' | translate}}
          </div>
          <br>
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'メールアドレス' | translate}}</mat-label>
              <input matInput placeholder="{{'メールアドレス' | translate}}" id="emailAddress" formControlName="emailAddress">
              <!-- <mat-error *ngIf="emailAddressControl.invalid">{{ getErrorMessageToEmailAddress() }}</mat-error> -->
            </mat-form-field>
            <mat-form-field *ngIf="reservationFacility.is_visibled_mobile_phone_number" fxFlex="50%">
              <mat-label floatLabel="always">{{'携帯電話番号' | translate}}</mat-label>
              <input matInput placeholder="{{'携帯電話番号' | translate}}" id="mobilePhoneNumber"
                formControlName="mobilePhoneNumber">
            </mat-form-field>
          </div>
          <br>
          <div fxLayout="row" *ngIf="reservationFacility.is_visibled_company_name" fxLayoutGap="20px">
            <mat-form-field fxFlex="100%">
              <mat-label floatLabel="always">{{'会社名' | translate}}</mat-label>
              <input matInput placeholder="{{'会社名' | translate}}" id="companyName" formControlName="companyName">
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_company_name">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field *ngIf="reservationFacility.is_visibled_department" fxFlex="100%">
              <mat-label floatLabel="always">{{'部署' | translate}}</mat-label>
              <input matInput placeholder="{{'部署' | translate}}" id="department" formControlName="department">
            </mat-form-field>
            <mat-form-field *ngIf="reservationFacility.is_visibled_job_title" fxFlex="50%">
              <mat-label floatLabel="always">{{'役職' | translate}}</mat-label>
              <input matInput placeholder="{{'役職' | translate}}" id="jobTitle" formControlName="jobTitle">
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_department || reservationFacility.is_visibled_job_title">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field *ngIf="reservationFacility.is_visibled_surname_chinese" fxFlex="50%">
              <mat-label floatLabel="always">{{'姓（漢字）' | translate}}</mat-label>
              <input matInput placeholder="{{'姓（漢字）' | translate}}" id="surnameChinese"
                formControlName="surnameChinese">
            </mat-form-field>
            <mat-form-field *ngIf="reservationFacility.is_visibled_name_chinese" fxFlex="50%">
              <mat-label floatLabel="always">{{'名（漢字）' | translate}}</mat-label>
              <input matInput placeholder="{{'名（漢字）' | translate}}" id="nameChinese" formControlName="nameChinese">
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_surname_chinese || reservationFacility.is_visibled_name_chinese">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field *ngIf="reservationFacility.is_visibled_family_name" fxFlex="50%">
              <mat-label floatLabel="always">{{'姓（カナ）' | translate}}</mat-label>
              <input matInput placeholder="{{'姓（カナ）' | translate}}" id="familyName" formControlName="familyName">
              <mat-error *ngIf="familyNameControl.invalid">{{ getErrorMessageToFamilyName() }}</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="reservationFacility.is_visibled_first_name" fxFlex="50%">
              <mat-label floatLabel="always">{{'名（カナ）' | translate}}</mat-label>
              <input matInput placeholder="{{'名（カナ）' | translate}}" id="firstName" formControlName="firstName">
              <mat-error *ngIf="familyNameControl.invalid">{{ getErrorMessageToFirstName() }}</mat-error>
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_family_name || reservationFacility.is_visibled_first_name">
          <div fxLayout="row" fxLayoutGap="20px">
            <mat-form-field *ngIf="reservationFacility.is_visibled_birthday" fxFlex="50%">
              <mat-label>{{'生年月日' | translate}}</mat-label>
              <input matInput [matDatepicker]="birthdayPicker" placeholder="{{'生年月日' | translate}}"
                formControlName="birthday" readonly>
              <button mat-button matSuffix aria-label="Clear" (click)="clearBirthday()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle matSuffix [for]="$any(birthdayPicker)"></mat-datepicker-toggle>
              <mat-datepicker #birthdayPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field *ngIf="reservationFacility.is_visibled_gender" fxFlex="50%">
              <mat-label>{{'性別' | translate}}</mat-label>
              <mat-select placeholder="{{'性別' | translate}}" id="gender" formControlName="gender">
                <mat-option *ngFor="let gender of genders" [value]="gender">{{ gender | gender }}</mat-option>
              </mat-select>
              <mat-error *ngIf="genderControl.invalid">{{ getErrorMessageToGender() }}</mat-error>
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_birthday || reservationFacility.is_visibled_gender">
          <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'郵便番号' | translate}}</mat-label>
              <input matInput placeholder="{{'郵便番号' | translate}}" id="postalCode" formControlName="postalCode">
            </mat-form-field>
          </div>
          <br>
          <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'都道府県' | translate}}</mat-label>
              <input matInput placeholder="{{'都道府県' | translate}}" id="prefecture" formControlName="prefecture">
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'市区町村' | translate}}</mat-label>
              <input matInput placeholder="{{'市区町村' | translate}}" id="municipalities" formControlName="municipalities">
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_address">
          <div *ngIf="reservationFacility.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'町名番地' | translate}}</mat-label>
              <input matInput placeholder="{{'町名番地' | translate}}" id="streetAddress" formControlName="streetAddress">
            </mat-form-field>
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'建物名・号室' | translate}}</mat-label>
              <input matInput placeholder="{{'建物名・号室' | translate}}" id="nameAndNumberBuilding"
                formControlName="nameAndNumberBuilding">
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_address">
          <div *ngIf="reservationFacility.is_visibled_user_request && !!reservationFacilities">
            <div *ngFor="let reservationFacility of reservationFacilities">
              <div
                *ngIf="!!reservation && reservation.reservation_facility_id === reservationFacility.reservation_facility_id">
                <label>{{ reservationFacility.reservation_user_input_titles |
                  multiUserInputTitle:projectLanguages:projectBaseLang }}</label>
              </div>
            </div>
          </div>
          <div *ngIf="reservationFacility.is_visibled_user_request" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="100%">
              <textarea matInput type="text" placeholder="" rows="5" formControlName="userRequest"></textarea>
            </mat-form-field>
          </div>
          <br *ngIf="reservationFacility.is_visibled_user_request">
        </form>

        <div *ngIf="questions && questions.length > 0 && reservation">
          {{'▼カスタム項目' | translate}}
          <br>
          <br>
          <form [formGroup]="applyForm">
            <div formArrayName="options">
              <div *ngFor="let option of options.controls; let i = index">
                <!-- 設問：共通 -->
                <!-- <mat-label fxLayout="row" fxLayoutGap="20px">
                  <span fxFlex="grow">{{questions[i].question_names[0].name }}</span>
                  <span *ngIf="isRequired(questions[i].question_check!)" class="reservation-note">{{'※必須' | translate}}</span>
                </mat-label> -->
                <!-- string -->
                <div fxLayout="row" fxLayoutGap="20px">
                  <mat-form-field *ngIf="questions[i].question_type == 'string'" [formGroupName]="i" fxFlex="100%">
                    <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                    <input matInput type="text" placeholder="{{questions[i].question_names[0].name}}" id="value"
                      formControlName="value">
                  </mat-form-field>
                  <!-- text-area -->
                  <mat-form-field *ngIf="questions[i].question_type == 'text-area'" [formGroupName]="i" fxFlex="100%">
                    <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                    <textarea matInput type="text" placeholder="{{questions[i].question_names[0].name}}" rows="5"
                      formControlName="value" class="!resize-none"></textarea>
                  </mat-form-field>
                  <!-- number -->
                  <mat-form-field class="reservation-form-field" *ngIf="questions[i].question_type == 'number'"
                    [formGroupName]="i" fxFlex="100%">
                    <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                    <input matInput type="number" placeholder="{{questions[i].question_names[0].name}}"
                      formControlName="value">
                  </mat-form-field>
                  <!-- select -->
                  <div *ngIf="questions[i].question_type == 'select'" [formGroupName]="i">
                    <mat-form-field class="reservation-form-field" fxFlex="100%">
                      <!-- <mat-select placeholder="{{'キャンセル期限' | translate}}" id="reservationCancel" formControlName="reservationCancel">
                      <mat-option *ngFor="let reservationCancel of reservationNumberDays" [value]="reservationCancel">{{ reservationCancel | numberDay }}</mat-option>
                    </mat-select> -->
                      <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                      <mat-select placeholder="{{questions[i].question_names[0].name}}" formControlName="value"
                        (selectionChange)="selectChange($event, i)">
                        <mat-option *ngIf="reservation" value=""></mat-option>
                        <mat-option *ngFor="let item of questions[i].question_select_items"
                          [value]="item.value">{{item.items[0].item}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <!-- checkbox -->
                  <div *ngIf="questions[i].question_type == 'checkbox'" [formGroupName]="i"
                    class="reservation-form-field">
                    <div class="reservation-check-group">
                      <div *ngFor="let item of questions[i].question_select_items; let j = index">
                        <mat-checkbox [checked]="option.value.value[j].value.selected"
                          (change)="checkToggle($event, i, j)" class="reservation-check-button">
                          {{item.items[0].item}}
                        </mat-checkbox>
                      </div>
                    </div>
                    <br>
                  </div>
                  <!-- radio -->
                  <div *ngIf="questions[i].question_type == 'radio'" [formGroupName]="i" class="reservation-form-field">
                    <mat-radio-group class="reservation-radio-group">
                      <div *ngFor="let item of questions[i].question_select_items; let j = index">
                        <mat-radio-button [value]="option.value.value[j].value.value"
                          [checked]="option.value.value[j].value.selected" (change)="radioChange($event, i)"
                          class="reservation-radio-button">
                          {{item.items[0].item}}
                        </mat-radio-button>
                      </div>
                    </mat-radio-group>
                    <br>
                  </div>
                  <br>
                </div>
              </div>
            </div>
          </form>
          <!-- <div *ngFor="let question of questions">
            <div *ngIf="question.question_type && question.question_type=='string'">
              <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="100%">
                  <input matInput placeholder="{{ question.question_names[0].name }}" id="streetAddress" formControlName="streetAddress">
                </mat-form-field>
              </div>
            </div>
          </div> -->

        </div>
      </div>
    </div>
  </div>
</div>

